import { changeRoleListProcessingState } from './role-list.actions';
import { getAxios } from 'utils/api/axiosClient';
import { API_METHODS, LOCAL_STORAGE_KEYS } from 'config/constants';
import { SubmissionError } from 'redux-form';
import { getReduxFormError } from 'utils/forms/getReduxFormError';
import { updateTokens } from './auth.actions';
import {
  changeProfileProcessingState,
  setProfileDataByKey,
} from './profile.actions';
import { clearLocalState, getFromLocalState } from 'utils/localStorage';
import { getPersonnelAccountSwitchPath } from 'utils/business-logic/getPersonnelAccountSwitchPath';

export const PERSONNEL_REGISTATION_ACTION_TYPES = {
  PERSONNEL_REGISTATION_CHANGE_PROCESSING:
    'PERSONNEL_REGISTATION_CHANGE_PROCESSING',
  PERSONNEL_REGISTATION_SEARCH_ORG: 'SEARCH_ORG',
  GET_JOB_TITLES_FOR_RESEARCH: 'GET_JOB_TITLES_FOR_RESEARCH',
  PERSONNEL_SET_DATA_BY_KEY: 'PERSONNEL_SET_DATA_BY_KEY',
  PERSONNEL_CLEAR_STATE: 'PERSONNEL_CLEAR_STATE',
};

export const changeFormProcessingState = (newState) => {
  return {
    type: PERSONNEL_REGISTATION_ACTION_TYPES.PERSONNEL_REGISTATION_CHANGE_PROCESSING,
    payload: newState,
  };
};

export const getOrganization = (url) => {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios.get(url);

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch({
      type: PERSONNEL_REGISTATION_ACTION_TYPES.PERSONNEL_REGISTATION_SEARCH_ORG,
      payload: {
        data,
      },
    });

    return response;
  };
};

export const getJobTitlesForResearchSite = ({ url, processingKey }) => {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeRoleListProcessingState(true, processingKey));

    const response = await axios.get(url);

    dispatch(changeRoleListProcessingState(false, processingKey));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch({
      type: PERSONNEL_REGISTATION_ACTION_TYPES.GET_JOB_TITLES_FOR_RESEARCH,
      payload: {
        data,
      },
    });

    return response;
  };
};

export function setDataByKey(data, stateKeyForDataSaving) {
  return {
    type: PERSONNEL_REGISTATION_ACTION_TYPES.PERSONNEL_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function getData(pageObject, stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeFormProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeFormProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data = {} } = response;
    dispatch(setDataByKey(data, stateKeyForDataSaving));

    return response;
  };
}

export const changePersonnelOrganization = (owner, organizationId) => {
  return async () => {
    const axios = getAxios();
    let response;

    if (owner === 'research-site') {
      response = await axios.put(
        API_METHODS.PERSONNEL_CURRENT_RESEARCH_SITE_BY_ID(organizationId),
      );
    } else if (owner === 'user') {
      response = await axios.put(API_METHODS.PERSONNEL_OWN_ACCOUNT);
    } else {
      response = await axios.put(API_METHODS.PERSONNEL_CURRENT_SPONSOR);
    }

    if (!response || response.code !== 'success') {
      throw new SubmissionError(getReduxFormError(response));
    }

    return response;
  };
};

/**
 * Switches personnel between personal and organization accounts.
 * Updates auth session, profile reload flag, and returns redirect path for header flows.
 */
export const switchPersonnelAccount = (
  owner,
  organizationId,
  { redirect = true } = {},
) => {
  return async (dispatch, getState) => {
    const response = await dispatch(
      changePersonnelOrganization(owner, organizationId),
    );

    if (!response?.data) {
      return { response, nextPath: null };
    }

    dispatch(changeProfileProcessingState(true, 'openWelcomeWindow'));
    dispatch(updateTokens(response.data));

    const profileState = getState()?.profileState ?? {};
    const { changeAccountFlag } = profileState;
    dispatch(
      setProfileDataByKey(
        { flag: !changeAccountFlag?.flag },
        'changeAccountFlag',
      ),
    );

    clearLocalState(LOCAL_STORAGE_KEYS.BREADCRUMBS_ARRAY);

    const updatedUserState = getFromLocalState(LOCAL_STORAGE_KEYS.USER);
    const updatedAuthInfo = updatedUserState?.authInfo;
    const nextPath =
      redirect && updatedAuthInfo
        ? getPersonnelAccountSwitchPath(owner, updatedAuthInfo)
        : null;

    return { response, nextPath };
  };
};
